import React from "react";
import styled from "styled-components";
import Hero from "components/pages/index/Hero";
import About from "components/pages/index/About";
import Stories, { getLatestStoriesQuery } from "components/pages/index/Stories";
import { FooterWithState } from "components/Footer";
import withApollo from "components/higher-order/withApollo";
import PageContainer from "components/containers/PageContainer";
import { JustSignedUpListener } from "components/listeners/JustSignedUpListener";
import { JustGaveGiftListener } from "components/listeners/JustGaveGiftListener";
import { NewsletterPopupForm } from "components/pages/index/NewsletterPopup";
import { isNil } from "lodash";
import { parseCookies } from "nookies";
import uuidv4 from "uuid/v4";
import { useHomepageState } from "components/optimized/Homepage/Homepage.hooks";
import request from "graphql-request";
import { baseUrl, isStagingEnvironment } from "services/shared/Environment";
import { categoriesQuery, categoryStoriesQuery } from "components/optimized/Homepage/Homepage.utils";
import { PagePropsProvider } from "components/optimized/Homepage/Homepage.components";
import { isDevelopment } from "apollo-utilities";

const browserIdCookieName = "juggernautBrowserId";

export const IndexPageContainer = styled.div.attrs({
  className: "w-screen flex flex-col items-center justify-center",
})`
  min-height: calc(100vh - 64px);
`;

const IndexPage = ({ categories, categoryStories, latestStories }) => {
  
  const { userIsLoggedIn, shouldHideHero, showPopup } = useHomepageState()

  return (
    <PageContainer>
      <PagePropsProvider
        latestStories={latestStories}
        categories={categories}
        categoryStories={categoryStories}
      >
        <JustSignedUpListener />
        <JustGaveGiftListener />
        <IndexPageContainer>
          {!userIsLoggedIn && !shouldHideHero && (
            <>
              <Hero />
              <About />
            </>
          )}
          <Stories />
        </IndexPageContainer>
        <FooterWithState />
        {showPopup ? <NewsletterPopupForm /> : <></>}
      </PagePropsProvider>
    </PageContainer>
  );
};

export async function getStaticProps() {

    const apiUrl = isDevelopment()
      ? "http://localhost:3000/api/graphql"
      : isStagingEnvironment()
      ? "https://staging.thejuggernaut.com/api/graphql"
      : "https://www.thejuggernaut.com/api/graphql";


  const result = await request(apiUrl, categoriesQuery());
  const categories = result?.categories ?? []
  const categoryStories = {}



  for(let i = 0; i < categories.length; i++) {
    const categoryId = categories[i]?.id ?? ''
    const result = await request(apiUrl, categoryStoriesQuery({ categoryId, numStoriesLoaded: 4 }))
    categoryStories[categoryId] = result?.categoryStories ?? []
  }

  const result2 = await request(apiUrl, getLatestStoriesQuery(4));

  const latestStories = result2?.latestStories ?? []
 
  return {
    props: {
      categories,
      categoryStories,
      latestStories
    },
    revalidate: 60,
  };
}

export default IndexPage
